import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getAutocompleteGlobalSearcher = async (
  dispatch: Dispatch,
  requesData: any,
) => {
  const { label, input } = requesData;
  const response = await requestHandler({
    method: 'post',
    url: `internal/search/globalSearcher/autocomplete`,
    data: { label, input },
    headers: {},
    dispatch,
  });
  if (response) return response.data;
};

export const preloadBusinessesGlobalSearcher = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/search/globalSearcher/preload-businesses`,
    data: {},
    headers: {},
    dispatch,
  });
  if (response) return response.data;
};
